// extracted by mini-css-extract-plugin
export var chip = "_3j-9";
export var chipLabel = "_3j-a";
export var close = "_3j-7";
export var closeIcon = "_3j-8";
export var error = "_3j-6";
export var infoTooltip = "_3j-2";
export var innerContainer = "_3j-1";
export var input = "_3j-b";
export var medium = "_3j-5";
export var outerContainer = "_3j-0";
export var small = "_3j-4";
export var xSmall = "_3j-3";